import axios from "../axiosPlugin.js";

// const domain = "http://127.0.0.1:4523/mock/573833";

// mock
export const getDiscountRuleTemplateList = data => {
  return axios({
    // url: `${domain}/api/discountRuleTemplate/list`,
    url: "/api/discountRuleTemplate/list",
    method: "GET",
    data: {
      data,
    },
  });
};

export const deleteRule = data => {
  return axios({
    url: `/api/discountRuleTemplate/delete/${data.id}`,
    method: "DELETE",
    data: {
      data,
    },
  });
};

export const createRule = data => {
  return axios({
    url: "/api/discountRuleTemplate/create",
    method: "POST",
    data: {
      data,
    }
  });
};

export const getRuleDetail = data => {
  return axios({
    url: `/api/discountRuleTemplate/detail/${data.id}`,
    method: "GET",
    data: {
      data,
    }
  });
};

export const updateRule = data => {
  return axios({
    url: "/api/discountRuleTemplate/update",
    method: "PUT",
    data: {
      data,
    }
  });
};